import React from 'react';
// import {getErrors} from 'redux/common';
// import {useDispatch} from 'react-redux';
import i18next from 'i18next';
import {Msg} from 'components/notifications/NotificationContext';
// import {action} from 'redux/helpers';
// import {loginTypes} from 'features/login/redux';

export const getFetchErrors = async (e: any, url?: string) => {
   console.debug('Handle api error', e, e.message, url, typeof e);
   let message =
      e.message ||
      e.error ||
      e.statusText ||
      e?.[0]?.message ||
      `${i18next.t('Get an error calling')} 
   ${url}`;
   let eBody = e.errorBody || e;
   try {
      eBody = await e.text();
      message = eBody || message;
      eBody = JSON.parse(eBody);
   } catch (bodyErr) {
      // console.debug(bodyErr);
   }
   // console.debug(eBody);

   try {
      message =
         (eBody?.errors?.length && `${eBody.errors.map((e: any) => e.message + '\n')}`) ||
         eBody.error ||
         message;
   } catch (e) {
      // console.debug(e);
   }

   return {message, error: eBody};
};

type Props = {
   url: string;
   setError?: (err: any) => void;
   setLoading?: (loading: boolean) => void;
   hideToast?: boolean;
};
export const useHandleApiError = ({url, setError, setLoading, hideToast}: Props) => {
   // const {addToast} = useToasts();

   // const dispatch = useDispatch();

   const handler = React.useCallback(
      (callback?: (e: Response, message: string, eOrigin: Response) => void) => (e: Response) => {
         return getFetchErrors(e, url).then(({message, error}) => {
            // console.debug(message);
            // console.debug(error);
            if (e.status === 401) {
               // dispatch(action(loginTypes.LOGIN.ERROR, e));
            }
            setError?.(error);
            setLoading?.(false);
            const hide = callback?.(error, message, e);
            !(hide || hideToast) && Msg.notify(message, 'error');
         });
      },
      [url, setError, setLoading]
   );

   return handler;
};
